import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

import { NOTIFICATION_TYPE } from '../../../../../constants/common'
import { useValidationWithoutFormikNotifications } from '../../../../../hooks'
import {
  DOCUMENT_MOVE_TO_ACTION_MODAL_VALIDATION_FIELD_CAN_WRITE,
  NOTIFICATION_ERROR_WRITE_FOLDER_PERMISSIONS,
} from '../../DocumentMoveToActionModal.constants'
import { getValidationSchema } from '../../DocumentMoveToActionModal.utils'

export function useDocumentMoveToActionModalValidation({
  notifications,
  parent,
  validateData,
  onRemoveNotification,
  onSetNotification,
}) {
  const { t } = useTranslation()

  const {
    isValidForm,
    notificationList,
    setValidationErrors,
    validationErrors,
  } = useValidationWithoutFormikNotifications({
    getValidationSchema,
    notifications,
    validateData,
    validationSchemaProps: { parent },
    onRemoveNotification,
    onSetNotification,
  })

  useEffect(() => {
    if (
      validationErrors[DOCUMENT_MOVE_TO_ACTION_MODAL_VALIDATION_FIELD_CAN_WRITE]
    ) {
      onSetNotification({
        id: NOTIFICATION_ERROR_WRITE_FOLDER_PERMISSIONS,
        text: t('Error.FolderWriteNotPermissionsKey'),
        type: NOTIFICATION_TYPE.error,
      })
    } else {
      onRemoveNotification(NOTIFICATION_ERROR_WRITE_FOLDER_PERMISSIONS)
    }
  }, [validationErrors])

  return {
    isValidForm,
    notificationList,
    setValidationErrors,
  }
}
